import React, { FC } from 'react';
import classnames from 'classnames';
import { IntlShape, useIntl } from 'react-intl';

import { ScreenReadersOnly } from '@/shared/components/ScreenReadersOnly/ScreenReadersOnly';
import { useRemainingTime } from '@/scenarios/legacy-player/hooks/useRemainingTime';

import { useFormattedTime } from './hooks/useFormattedTime';
import styles from './styles.module.css';

interface Props {
    className?: string;
}

const getAriaRemainingTime = (intl: IntlShape, remainingSeconds: number) => {
    const hours = Math.floor(remainingSeconds / (60 * 60));
    const minutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(remainingSeconds % 60);

    const hoursRendered = hours
        ? intl.formatMessage(
              {
                  id: 'features.player.4ca9ffc6fa33e774dec2f6511b30b53b',
                  defaultMessage: '{hours, plural, one {# hour} few {# hours} other {# hours}}',
                  description:
                      'Плюральная форма для часов, используется в ариа атрибутах оставшегося времени',
              },
              { hours }
          )
        : '';
    const minutesRendered = minutes
        ? intl.formatMessage(
              {
                  id: 'features.player.fa824b16c647789f41e7a9a3dd0c9006',
                  defaultMessage:
                      '{minutes, plural, one {# minute} few {# minutes} other {# minutes}}',
                  description:
                      'Плюральная форма для минут, используется в ариа атрибутах оставшегося времени',
              },
              { minutes }
          )
        : '';
    const secondsRendered = hours
        ? intl.formatMessage(
              {
                  id: 'features.player.c40b1f9e601ee0ca94dabcb598160bbc',
                  defaultMessage:
                      '{seconds, plural, one {# second} few {# seconds} other {# seconds}}',
                  description:
                      'Плюральная форма для секунд, используется в ариа атрибутах оставшегося времени',
              },
              { seconds }
          )
        : '';

    const renderedDuration = [hoursRendered, minutesRendered, secondsRendered]
        .filter(Boolean)
        .join(' ');

    return renderedDuration
        ? intl.formatMessage(
              {
                  id: 'features.player.75a0c44c76ccbc71dc8cb343396d77f2',
                  defaultMessage: 'Remaining time {renderedDuration}',
                  description:
                      'Текст для оставшегося времени, renderDuration - оставшееся время текстом (1 час 22 минуты 35 секунд)',
              },
              { renderedDuration }
          )
        : '';
};

export const RemainingTime: FC<Props> = ({ className }) => {
    const intl = useIntl();

    const formattedTime = useFormattedTime();
    const remainingSeconds = useRemainingTime();

    if (!formattedTime) {
        return null;
    }

    return (
        <>
            <ScreenReadersOnly>{getAriaRemainingTime(intl, remainingSeconds)}</ScreenReadersOnly>
            <div className={classnames(styles.root, className)} aria-hidden>
                &minus;{formattedTime}
            </div>
        </>
    );
};
